/**
 * Billing Page
 *
 * Re-exports the BillingPage component from billing module.
 */

import { BillingPage } from '../billing';

export default BillingPage;
